export { default } from "./ChangeColor";
